// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Default styles */
.index-module__social-link-container__d_0MC {
  display: flex;
  justify-content: space-around;
  align-items: center;
  gap: 15px;
}
.index-module__icon-size__TPmjv {
  height: 25px;
  width: 25px;
}
/* Media queries */
/* Mobile screens (max-width: 576px) */
@media (max-width: 576px) {
  .index-module__social-link-container__d_0MC {
    gap: 10px;
  }
  .index-module__icon-size__TPmjv {
    height: 18px;
    width: 18px;
  }
}
/* Tablets (min-width: 577px and max-width: 768px) */
@media (min-width: 577px) and (max-width: 768px) {
  .index-module__social-link-container__d_0MC {
    gap: 13px;
  }
  .index-module__icon-size__TPmjv {
    height: 22px;
    width: 22px;
  }
}
/* Laptops (min-width: 769px and max-width: 1024px) */
@media (min-width: 769px) and (max-width: 1024px) {
  .index-module__icon-size__TPmjv {
    height: 25px;
    width: 25px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/common/SocialMediaLinks/index.module.less"],"names":[],"mappings":"AAAA,mBAAmB;AACnB;EACE,aAAa;EACb,6BAA6B;EAC7B,mBAAmB;EACnB,SAAS;AACX;AACA;EACE,YAAY;EACZ,WAAW;AACb;AACA,kBAAkB;AAClB,sCAAsC;AACtC;EACE;IACE,SAAS;EACX;EACA;IACE,YAAY;IACZ,WAAW;EACb;AACF;AACA,oDAAoD;AACpD;EACE;IACE,SAAS;EACX;EACA;IACE,YAAY;IACZ,WAAW;EACb;AACF;AACA,qDAAqD;AACrD;EACE;IACE,YAAY;IACZ,WAAW;EACb;AACF","sourcesContent":["/* Default styles */\n.social-link-container {\n  display: flex;\n  justify-content: space-around;\n  align-items: center;\n  gap: 15px;\n}\n.icon-size {\n  height: 25px;\n  width: 25px;\n}\n/* Media queries */\n/* Mobile screens (max-width: 576px) */\n@media (max-width: 576px) {\n  .social-link-container {\n    gap: 10px;\n  }\n  .icon-size {\n    height: 18px;\n    width: 18px;\n  }\n}\n/* Tablets (min-width: 577px and max-width: 768px) */\n@media (min-width: 577px) and (max-width: 768px) {\n  .social-link-container {\n    gap: 13px;\n  }\n  .icon-size {\n    height: 22px;\n    width: 22px;\n  }\n}\n/* Laptops (min-width: 769px and max-width: 1024px) */\n@media (min-width: 769px) and (max-width: 1024px) {\n  .icon-size {\n    height: 25px;\n    width: 25px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"social-link-container": `index-module__social-link-container__d_0MC`,
	"icon-size": `index-module__icon-size__TPmjv`
};
export default ___CSS_LOADER_EXPORT___;
